module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/more-topic-3-mobile.4c4256ca.jpg";